import {
  ALL_COUNTRIES_CODE,
  ALL_COUNTRIES_LABEL,
  DataTableCellFormatType,
} from '../../constants';
import { pathOr } from 'rambda';
import { toDateFormat } from './date-formatter';
import {
  numberFormat,
  numbersWithFloatPointFormat,
  toPriceFormat,
} from './number-formatter';

export * from './date-formatter';
export * from './number-formatter';

export function formatCellByType<T>(
  item: T,
  field: string,
  type: DataTableCellFormatType,
): string {
  const value = item[field];

  switch (type) {
    case DataTableCellFormatType.CountryName:
      const code = pathOr(ALL_COUNTRIES_CODE, ['code'], item);
      const name = pathOr('', ['name'], item);

      if (code === ALL_COUNTRIES_CODE) {
        return ALL_COUNTRIES_LABEL;
      }

      if (!name) {
        return code;
      }

      return `${code} - ${name}`;
    case DataTableCellFormatType.Date:
      return toDateFormat(String(value));
    case DataTableCellFormatType.Number:
      return numberFormat(value);
    case DataTableCellFormatType.Price:
      return toPriceFormat(value);
    case DataTableCellFormatType.Float:
      return numberFormat(value);
    case DataTableCellFormatType.FloatPoint:
      return numbersWithFloatPointFormat(value);
    default:
      return String(value);
  }
}
